// import { Box, Button, MenuItem, Modal, Rating, Select } from "@mui/material";
// import React, {
//   useCallback,
//   useEffect,
//   useMemo,
//   useRef,
//   useState,
// } from "react";
// import { isValidMobileNumber } from "../../../shared/utils";
// import ReactQuill from "react-quill";

// const style = {
//   position: "absolute",
//   top: "50%",
//   left: "50%",
//   transform: "translate(-50%, -50%)",
//   width: "90%",
//   maxWidth: "800px",
//   maxHeight: "90vh",
//   bgcolor: "background.paper",
//   boxShadow: 24,
//   p: 2,
//   overflowY: "auto",
//   "&::-webkit-scrollbar": {
//     width: "4px",
//   },
//   "&::-webkit-scrollbar-track": {
//     background: "#f1f1f1",
//   },
//   "&::-webkit-scrollbar-thumb": {
//     background: "#888",
//     borderRadius: "4px",
//   },
//   "&::-webkit-scrollbar-thumb:hover": {
//     background: "#555",
//   },
//   "@media (min-width: 600px)": {
//     width: "80%",
//     p: 3,
//   },
//   "@media (min-width: 900px)": {
//     width: "70%",
//   },
//   "@media (min-width: 1200px)": {
//     width: "60%",
//   },
// };

// const AddShowRoomModal = (props) => {
//   const { open, handleClose, selectedStore, handleStore, storeType } = props;

//   const prevProp = useRef();

//   const [state, setState] = useState({
//     _id: "",
//     name: "",
//     short_name: "",
//     pincode: "",
//     state_alias: "",
//     address: "",
//     map: "",
//     direction: "",
//     contactNumber: "",
//     rating: 0,
//     status: "active",
//   });
//   const [error, setError] = useState({});

//   useEffect(() => {
//     if (!prevProp?.current?.open && open) {
//       setState({
//         _id: selectedStore?._id ?? "",
//         name: selectedStore?.name ?? "",
//         short_name: selectedStore?.short_name ?? "",
//         state_alias: selectedStore?.state_alias ?? "",
//         pincode: selectedStore?.pincode ?? "",
//         address: selectedStore?.address ?? "",
//         map: selectedStore?.map ?? "",
//         direction: selectedStore?.direction ?? "",
//         contactNumber: selectedStore?.contactNumber ?? "",
//         rating: selectedStore?.rating ?? 0,
//         status: selectedStore?.status ?? "active", // ✅ prefill active status if editing
//       });
//       setError({});
//     }

//     return () => {
//       prevProp.current = {
//         open,
//       };
//     };
//   }, [open, selectedStore]);

//   useEffect(() => {
//     if (!selectedStore && open) {
//       setState((prev) => ({ ...prev, status: "active" }));
//     }
//   }, [open, selectedStore]);

//   const handleChange = useCallback(
//     (name) => (e) => {
//       let value = e?.target?.value ?? e;

//       if (name === "contactNumber") {
//         value = value.replace(/[^0-9]/g, "");
//         value = value.slice(0, 10);
//       }

//       if (name === "pincode") {
//         value = value.replace(/[^0-9]/g, ""); // ⛔ remove dots & letters
//         value = value.slice(0, 6); // limit to 6 digits
//       }

//       if (name === "rating") {
//         value = Number(value);
//       }
//       setState((preState) => ({ ...preState, [name]: value }));
//       setError({});
//     },
//     []
//   );

//   const modalTitle = useMemo(
//     () => (selectedStore ? `Edit ${storeType}` : `Add ${storeType}`),
//     [selectedStore, storeType]
//   );

//   // const hasError = useCallback(() => {
//   //   let {
//   //     name,
//   //     address,
//   //     map,
//   //     contactNumber,
//   //     rating,
//   //     direction,
//   //     short_name,
//   //     pincode,
//   //     state_alias,
//   //   } = state;
//   //   name = name?.trim?.();
//   //   address = address?.trim?.();
//   //   short_name = short_name?.trim?.();
//   //   pincode = pincode?.trim?.();

//   //   const error = {};

//   //   if (!name) {
//   //     error.name = "Name cannot be blank";
//   //   }
//   //   if (!short_name) {
//   //     error.short_name = "short name cannot be blank";
//   //   }
//   //   if (!pincode) {
//   //     error.pincode = "pincode cannot be empty";
//   //   }
//   //   if (!state_alias) {
//   //     error.state_alias = "state alias cannot be empty ";
//   //   }

//   //   if (!address) {
//   //     error.address = "Address cannot be blank";
//   //   }
//   //   if (!direction) {
//   //     error.direction = "Map's direction cannot be blank";
//   //   }
//   //   if (!map) {
//   //     error.map = "Embed link required";
//   //   }
//   //   if (!contactNumber) {
//   //     error.contactNumber = "Contact number is required";
//   //   }
//   //   if (!rating) {
//   //     error.rating = "Rating is required";
//   //   }
//   //   if (contactNumber && !isValidMobileNumber(contactNumber)) {
//   //     error.contactNumber = "Invalid number";
//   //   }

//   //   setError(error);
//   //   return Object.keys(error).length;
//   // }, [state]);

//   const hasError = useCallback(() => {
//     const isServiceCentre = storeType === "Service Centre";

//     let {
//       name,
//       address,
//       map,
//       contactNumber,
//       rating,
//       direction,
//       short_name,
//       pincode,
//       state_alias,
//     } = state;

//     name = name?.trim?.();
//     address = address?.trim?.();
//     short_name = short_name?.trim?.();
//     pincode = pincode?.trim?.();

//     const error = {};

//     // Always required
//     if (!name) {
//       error.name = "Name cannot be blank";
//     }
//     if (!pincode) {
//       error.pincode = "pincode cannot be empty";
//     }
//     if (!address) {
//       error.address = "Address cannot be blank";
//     }
//     if (!rating) {
//       error.rating = "Rating is required";
//     }

//     // ❌ These should NOT be mandatory for Service Centre
//     if (!isServiceCentre) {
//       if (!short_name) {
//         error.short_name = "short name cannot be blank";
//       }
//       if (!state_alias) {
//         error.state_alias = "state alias cannot be empty";
//       }
//       if (!direction) {
//         error.direction = "Map's direction cannot be blank";
//       }
//       if (!map) {
//         error.map = "Embed link required";
//       }
//       if (!contactNumber) {
//         error.contactNumber = "Contact number is required";
//       }
//       if (contactNumber && !isValidMobileNumber(contactNumber)) {
//         error.contactNumber = "Invalid number";
//       }
//       if (!pincode) {
//         error.pincode = "pincode cannot be empty";
//       }
//       if (!address) {
//         error.address = "Address cannot be blank";
//       }
//     }

//     setError(error);
//     return Object.keys(error).length;
//   }, [state, storeType]);

//   const onSubmit = useCallback(() => {
//     if (!hasError()) {
//       const payload = {
//         ...state,
//       };

//       if (selectedStore && selectedStore.index !== undefined)
//         payload.index = selectedStore.index;
//       handleStore(payload);
//       handleClose(false);
//     }
//   }, [hasError, state, selectedStore, handleStore, handleClose]);

//   const isServiceCentre = storeType === "Service Centre";

//   return (
//     <Modal open={open} onClose={handleClose}>
//       <Box sx={style}>
//         <h2>{modalTitle}</h2>
//         <div className="form_comp">
//           <label htmlFor="title">
//             Name
//             <sup style={{ color: "red" }}>*</sup>
//           </label>

//           <input
//             type="text"
//             placeholder="Enter Name"
//             value={state.name}
//             onChange={handleChange("name")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.name}</span>
//         </div>

//         <div className="form_comp">
//           <label htmlFor="title">
//             short Name
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>

//           <input
//             type="text"
//             placeholder="Enter Name"
//             value={state.short_name}
//             onChange={handleChange("short_name")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.short_name}</span>
//         </div>
//         <div className="form_comp">
//           <label htmlFor="title">
//             pincode
//             <sup style={{ color: "red" }}>*</sup>
//           </label>

//           <input
//             type="text"
//             placeholder="Enter pincode"
//             value={state.pincode}
//             onChange={handleChange("pincode")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.pincode}</span>
//         </div>

//         <div className="form_comp">
//           <label htmlFor="title">
//             state alias
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>

//           <input
//             type="text"
//             placeholder="Enter state alias"
//             value={state.state_alias}
//             onChange={handleChange("state_alias")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.state_alias}</span>
//         </div>

//         <div className="form_comp">
//           <label htmlFor="title">
//             Status
//             <sup style={{ color: "red" }}>*</sup>
//           </label>
//           <Select
//             style={{ height: 40 }}
//             value={state.status}
//             onChange={handleChange("status")}
//           >
//             <MenuItem value={"active"}>Active</MenuItem>
//             <MenuItem value={"inactive"}>Inactive</MenuItem>
//           </Select>
//         </div>

//         <div className="form_comp">
//           <label htmlFor="title">
//             Address
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>
//           <ReactQuill
//             placeholder="Enter address"
//             value={state.address}
//             onChange={handleChange("address")}
//             theme="snow"
//             className="edit_container"
//             bounds={`[data-text-editor="name"]`}
//           />

//           <span className="error mt5">{error.address}</span>
//         </div>
//         <div className="form_comp">
//           <label htmlFor="title">
//             Google Map's embed link
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>
//           <textarea
//             rows="2"
//             placeholder="Enter iframe"
//             value={state.map}
//             onChange={handleChange("map")}
//           />
//           <span className="error mt5">{error.map}</span>
//         </div>
//         <div className="form_comp">
//           <label htmlFor="title">
//             Direction
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>

//           <input
//             type="text"
//             placeholder="Eg. goo.gl/maps/YFAvikeRhVRSYGbh7"
//             value={state.direction}
//             onChange={handleChange("direction")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.direction}</span>
//         </div>
//         <div className="form_comp">
//           <label htmlFor="title">
//             Contact Number
//             {/* <sup style={{ color: "red" }}>*</sup> */}
//             {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
//           </label>

//           <input
//             type="text"
//             maxLength={10}
//             placeholder="Enter contact number"
//             value={state.contactNumber}
//             onChange={handleChange("contactNumber")}
//             autoComplete="off"
//           />
//           <span className="error mt5">{error.contactNumber}</span>
//         </div>
//         <div className="form_comp">
//           <label htmlFor="title">
//             Rating
//             <sup style={{ color: "red" }}>*</sup>
//           </label>
//           <Rating
//             style={{ width: "max-content" }}
//             name="simple-controlled"
//             value={state.rating}
//             onChange={handleChange("rating")}
//           />
//           <span className="error mt5">{error.rating}</span>
//         </div>
//         <div
//           style={{
//             marginTop: 20,
//             display: "flex",
//             gap: 15,
//           }}
//         >
//           <Button variant="contained" onClick={onSubmit}>
//             {selectedStore ? "Update" : "Add"}
//           </Button>
//           <Button
//             variant="text"
//             className="bordered-button"
//             onClick={handleClose}
//           >
//             Cancel
//           </Button>
//         </div>
//       </Box>
//     </Modal>
//   );
// };

// export default AddShowRoomModal;

import { Box, Button, MenuItem, Modal, Rating, Select } from "@mui/material";
import React, {
  useCallback,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react";
import { isValidMobileNumber } from "../../../shared/utils";
import ReactQuill from "react-quill";

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "90%",
  maxWidth: "800px",
  maxHeight: "90vh",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 2,
  overflowY: "auto",
  "&::-webkit-scrollbar": { width: "4px" },
  "&::-webkit-scrollbar-track": { background: "#f1f1f1" },
  "&::-webkit-scrollbar-thumb": { background: "#888", borderRadius: "4px" },
  "&::-webkit-scrollbar-thumb:hover": { background: "#555" },
  "@media (min-width: 600px)": { width: "80%", p: 3 },
  "@media (min-width: 900px)": { width: "70%" },
  "@media (min-width: 1200px)": { width: "60%" },
};

const AddShowRoomModal = (props) => {
  const { open, handleClose, selectedStore, handleStore, storeType } = props;

  const prevProp = useRef();

  const [state, setState] = useState({
    _id: "",
    name: "",
    short_name: "",
    zoho_id: "",
    location_type: "",
    pincode: "",
    state_alias: "",
    address: "",
    map: "",
    direction: "",
    contactNumber: "",
    rating: 0,
    status: "active",
  });

  const [error, setError] = useState({});

  useEffect(() => {
    if (!prevProp?.current?.open && open) {
      setState({
        _id: selectedStore?._id ?? "",
        name: selectedStore?.name ?? "",
        short_name: selectedStore?.short_name ?? "",
        zoho_id: selectedStore?.zoho_id ?? "",
        location_type: selectedStore?.location_type ?? "",
        state_alias: selectedStore?.state_alias ?? "",
        pincode: selectedStore?.pincode ?? "",
        address: selectedStore?.address ?? "",
        map: selectedStore?.map ?? "",
        direction: selectedStore?.direction ?? "",
        contactNumber: selectedStore?.contactNumber ?? "",
        rating: selectedStore?.rating ?? 0,
        status: selectedStore?.status ?? "active",
      });
      setError({});
    }

    return () => {
      prevProp.current = { open };
    };
  }, [open, selectedStore]);

  useEffect(() => {
    if (!selectedStore && open) {
      setState((prev) => ({ ...prev, status: "active" }));
    }
  }, [open, selectedStore]);

  const handleChange = useCallback(
    (name) => (e) => {
      let value = e?.target?.value ?? e;

      if (name === "contactNumber") {
        value = value.replace(/[^0-9]/g, "").slice(0, 10);
      }

      if (name === "pincode") {
        value = value.replace(/[^0-9]/g, "").slice(0, 6);
      }

      if (name === "rating") {
        value = Number(value);
      }

      setState((preState) => ({ ...preState, [name]: value }));
      setError({});
    },
    [],
  );

  const modalTitle = useMemo(
    () => (selectedStore ? `Edit ${storeType}` : `Add ${storeType}`),
    [selectedStore, storeType],
  );

  // --------------------------------------
  // NEW CORRECT VALIDATION
  // --------------------------------------
  const hasError = useCallback(() => {
    const isServiceCentre = storeType === "Service Centre";

    let {
      name,
      address,
      map,
      contactNumber,
      rating,
      direction,
      short_name,
      pincode,
      state_alias,
    } = state;

    name = name?.trim?.();
    address = address?.trim?.();
    short_name = short_name?.trim?.();
    pincode = pincode?.trim?.();

    const error = {};

    // Always required
    if (!name) error.name = "Name cannot be blank";
    if (!rating) error.rating = "Rating is required";

    // Showroom-only required fields
    if (!isServiceCentre) {
      if (!short_name) error.short_name = "Short name cannot be blank";
      if (!pincode) error.pincode = "Pincode cannot be empty";
      if (!state_alias) error.state_alias = "State alias cannot be empty";
      if (!address) error.address = "Address cannot be blank";
      if (!direction) error.direction = "Map direction cannot be blank";
      if (!map) error.map = "Embed link required";
      if (!contactNumber) error.contactNumber = "Contact number is required";
      if (contactNumber && !isValidMobileNumber(contactNumber)) {
        error.contactNumber = "Invalid number";
      }
    }

    setError(error);
    return Object.keys(error).length;
  }, [state, storeType]);

  const onSubmit = useCallback(() => {
    if (!hasError()) {
      const payload = { ...state };

      if (selectedStore && selectedStore.index !== undefined)
        payload.index = selectedStore.index;

      handleStore(payload);
      handleClose(false);
    }
  }, [hasError, state, selectedStore, handleStore, handleClose]);

  const isServiceCentre = storeType === "Service Centre";

  return (
    <Modal open={open} onClose={handleClose}>
      <Box sx={style}>
        <h2>{modalTitle}</h2>

        {/* NAME */}
        <div className="form_comp">
          <label>
            Name <sup style={{ color: "red" }}>*</sup>
          </label>
          <input
            type="text"
            placeholder="Enter Name"
            value={state.name}
            onChange={handleChange("name")}
            autoComplete="off"
          />
          <span className="error mt5">{error.name}</span>
        </div>

        {/* SHORT NAME */}
        <div className="form_comp">
          <label>
            Short Name{" "}
            {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <input
            type="text"
            placeholder="Enter Short Name"
            value={state.short_name}
            onChange={handleChange("short_name")}
            autoComplete="off"
          />
          <span className="error mt5">{error.short_name}</span>
        </div>

        {/* ZOHO ID */}
        <div className="form_comp">
          <label>ZOHO ID</label>
          <input
            type="text"
            placeholder="Enter Zoho ID"
            value={state.zoho_id}
            onChange={handleChange("zoho_id")}
            autoComplete="off"
          />
          <span className="error mt5">{error.zoho_id}</span>
        </div>
        {/* ZOHO ID */}
        {/*Location Type*/}
        <div className="form_comp">
          <label>Location Type</label>
          {/* <input
            type="text"
            placeholder="Enter Location Type"
            value={state.location_type}
            onChange={handleChange("location_type")}
            autoComplete="off"
          /> */}
          {/* <select
            value={state.location_type}
            onChange={handleChange("location_type")}
          >
            <option value="">Select Location Type</option>
            <option value="showroom">COCO</option>
            <option value="service_centre">FOFO</option>
          </select> */}
          <Select
            value={state.location_type}
            onChange={handleChange("location_type")}
            displayEmpty
            style={{ height: 40 }}
          >
            <MenuItem value="">
              <em>Select Location Type</em>
            </MenuItem>

            <MenuItem value="COCO">COCO</MenuItem>
            <MenuItem value="FOFO">FOFO</MenuItem>
          </Select>
          <span className="error mt5">{error.location_type}</span>
        </div>
        {/*Location type*/}

        {/* PINCODE */}
        <div className="form_comp">
          <label>
            Pincode {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <input
            type="text"
            placeholder="Enter pincode"
            value={state.pincode}
            onChange={handleChange("pincode")}
            autoComplete="off"
          />
          <span className="error mt5">{error.pincode}</span>
        </div>

        {/* STATE ALIAS */}
        <div className="form_comp">
          <label>
            State Alias{" "}
            {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <input
            type="text"
            placeholder="Enter state alias"
            value={state.state_alias}
            onChange={handleChange("state_alias")}
            autoComplete="off"
          />
          <span className="error mt5">{error.state_alias}</span>
        </div>

        {/* STATUS */}
        <div className="form_comp">
          <label>
            Status <sup style={{ color: "red" }}>*</sup>
          </label>
          <Select
            style={{ height: 40 }}
            value={state.status}
            onChange={handleChange("status")}
          >
            <MenuItem value={"active"}>Active</MenuItem>
            <MenuItem value={"inactive"}>Inactive</MenuItem>
          </Select>
        </div>

        {/* ADDRESS */}
        <div className="form_comp">
          <label>
            Address {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <ReactQuill
            placeholder="Enter address"
            value={state.address}
            onChange={handleChange("address")}
            theme="snow"
          />
          <span className="error mt5">{error.address}</span>
        </div>

        {/* MAP */}
        <div className="form_comp">
          <label>
            Google Map's embed link{" "}
            {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <textarea
            rows="2"
            placeholder="Enter iframe"
            value={state.map}
            onChange={handleChange("map")}
          />
          <span className="error mt5">{error.map}</span>
        </div>

        {/* DIRECTION */}
        <div className="form_comp">
          <label>
            Direction{" "}
            {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <input
            type="text"
            placeholder="Eg. goo.gl/maps/YFAvikeRhVRSYGbh7"
            value={state.direction}
            onChange={handleChange("direction")}
            autoComplete="off"
          />
          <span className="error mt5">{error.direction}</span>
        </div>

        {/* CONTACT NUMBER */}
        <div className="form_comp">
          <label>
            Contact Number{" "}
            {!isServiceCentre && <sup style={{ color: "red" }}>*</sup>}
          </label>
          <input
            type="text"
            maxLength={10}
            placeholder="Enter contact number"
            value={state.contactNumber}
            onChange={handleChange("contactNumber")}
            autoComplete="off"
          />
          <span className="error mt5">{error.contactNumber}</span>
        </div>

        {/* RATING */}
        <div className="form_comp">
          <label>
            Rating <sup style={{ color: "red" }}>*</sup>
          </label>
          <Rating
            style={{ width: "max-content" }}
            name="simple-controlled"
            value={state.rating}
            onChange={handleChange("rating")}
          />
          <span className="error mt5">{error.rating}</span>
        </div>

        {/* BUTTONS */}
        <div style={{ marginTop: 20, display: "flex", gap: 15 }}>
          <Button variant="contained" onClick={onSubmit}>
            {selectedStore ? "Update" : "Add"}
          </Button>
          <Button
            variant="text"
            className="bordered-button"
            onClick={handleClose}
          >
            Cancel
          </Button>
        </div>
      </Box>
    </Modal>
  );
};

export default AddShowRoomModal;
